import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { LayoutBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { alignItems } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/alignItems";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { backgroundSize } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundSize";
import { borderColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderColor";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { borderStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderStyle";
import { borderWidth } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderWidth";
import { flexDirection } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/flexDirection";
import { flexWrap } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/flexWrap";
import { gap } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/gap";
import { justifyContent } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/justifyContent";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  BackgroundProp,
  DesignProp,
  GeneralProp,
  LayoutProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";

import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Stack",
  version: 1,
  nameI18n: "builder_ui.block_type.stack",
  category: [LayoutBlock],
  props: {
    children: {
      name: "Children",
      nameI18n: "builder_ui.prop_type.children",
      category: [LayoutProp],
      prop: "children",
      type: "children",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        flexDirection: {
          ...flexDirection,
          defaultValue: defaultStyles.flexDirection,
        },
        alignItems: {
          ...alignItems,
          defaultValue: defaultStyles.alignItems,
        },
        justifyContent: {
          ...justifyContent,
          defaultValue: defaultStyles.justifyContent,
        },
        flexWrap: {
          ...flexWrap,
          defaultValue: defaultStyles.flexWrap,
        },
        gap: {
          ...gap,
          defaultValue: defaultStyles.gap,
        },
        backgroundColor: {
          ...backgroundColor,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.backgroundColor,
        },
        backgroundImage: {
          ...backgroundImage,
          category: [DesignProp, BackgroundProp],
        },
        backgroundSize: {
          ...backgroundSize,
          category: [DesignProp, BackgroundProp],
          defaultValue: defaultStyles.backgroundSize,
        },
        borderWidth: {
          ...borderWidth,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderWidth,
        },
        borderColor: {
          ...borderColor,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderColor,
        },
        borderRadius: {
          ...borderRadius,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderRadius,
        },
        borderStyle: {
          ...borderStyle,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderStyle,
        },
        sizing: {
          ...sizing,
          category: [DesignProp, SizingProp],
          defaultValue: defaultStyles.sizing,
        },
        margin: {
          ...margin,
          category: [DesignProp, MarginsProp],
          defaultValue: defaultStyles.margin,
        },
        padding: {
          ...padding,
          category: [DesignProp, PaddingsProp],
          defaultValue: defaultStyles.padding,
        },
      },
    },
  },
};
